import { HttpHandler, HttpInterceptor, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

export class LanguageInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const value = localStorage.getItem('language');
    let cloned;

    if (value) {
      if (value === 'cs') {
        cloned = request.clone({
          headers: request.headers.set('Accept-Language',
            'cs-CZ')
        });
      }

      if (value === 'de') {
        cloned = request.clone({
          headers: request.headers.set('Accept-Language',
            'de-DE')
        });
      }

      if (value === 'en') {
        cloned = request.clone({
          headers: request.headers.set('Accept-Language',
            'en-US')
        });
      }
    } else {
      cloned = request.clone({
        headers: request.headers.set('Accept-Language',
          'cs-CZ')
      });    
    }

    return next.handle(cloned);
  }
}
